export default "__VITE_ASSET__ve1UddBy__"